export const getInitialInstagramCouponValues = date => ({
  type: 'INSTAGRAM_COUPON',
  status: 'draft',
  startDate: date,
  endDate: date,
  actions: [
    {
      failure: [],
      success: [
        {
          type: 'Send Instagram DM'
        },
        {
          type: 'Google Sheet Append',
          action: 'GOOGLE_SHEET_APPEND',
          sheetUrl: '',
          row: ''
        }
      ],
      triggers: [
        {
          type: 'Comments On Post'
        },
        {
          type: 'Match Hashtag',
          value: []
        }
      ],
      platform: 'instagram',
      description: 'Opt-In',
      operator: 'all'
    }
  ],
  moderated: false,
  moderators: { handles: [] },
  automated: false,
  threshold: 20,
  enableFiltering: false,
  enableBlastFiltering: false,
  store: false,
  profanity: false,
  lock: false
})



// WEBPACK FOOTER //
// ./src/pages/widgets/instagram-coupon/create/container/initialValues.js